export const colors = [
    '#0088FE',
    '#00C49F',
    '#FFBB28',
    '#000080',
    '#00008B',
    '#0000CD',
    '#0000FF',
    '#006400',
    '#008000',
    '#008B8B',
    '#008B8B',
    '#191970',
    '#20B2AA',
    '#228B22',
    '#2E8B57',
    '#32CD32',
    '#3CB371',
    '#4169E1',
    '#4B0082',
    '#5F9EA0',
    '#6495ED',
    '#66CDAA',
    '#7FFFD4',
    '#800080',
    '#8B0000',
    '#8B008B',
    '#8B4513',
    '#9400D3',
    '#9932CC',
    '#A0522D',
    '#A52A2A',
    '#B0E0E6',
    '#B22222',
    '#BA55D3',
    '#BC8F8F',
    '#CD5C5C',
    '#CD853F',
    '#D2691E',
    '#D8BFD8',
    '#DC143C',
    '#E0FFFF',
    '#E0FFFF',
    '#F08080',
    '#F0FFF0',
    '#F0FFFF',
    '#F4A460',
    '#a52a2a',
    '#ff0000',
    '#FF8042',
    '#8a2be2'
];


// WEBPACK FOOTER //
// ./src/app/common/util/color.const.util.js